<template>
  <div class="pcb-form">
    <BaseFormItem label="板材类型">
      <BaseRadioGroup v-model="val" @change="val => $emit('input', val)">
        <el-radio-button label="FR-4">FR-4(硬板)</el-radio-button>
        <el-radio-button label="FPC">FPC(软板)</el-radio-button>
      </BaseRadioGroup>
    </BaseFormItem>
    <component ref="componentRef" :is="{ 'FR-4': Fr4Form, 'FPC': FpcForm }[val]" v-bind="$attrs" />
  </div>
</template>

<script>
import Fr4Form from './fr4Form'
import FpcForm from './fpcForm'

import { FR4_DEFAULT_FORM, FPC_DEFAULT_FORM } from '@@/utils/defaultForm'

export default {
  props: {
    value: {
      type: String,
      default: 'FR-4'
    }
  },
  components: {
    Fr4Form,
    FpcForm
  },
  // inject: {
  //   pcbParams: { default: { ...FR4_DEFAULT_FORM } },
  //   fpcParams: { default: { ...FPC_DEFAULT_FORM } },
  // },
  data() {
    return {
      val: this.value,
      Fr4Form,
      FpcForm
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  }
}
</script>

<style lang="scss">
.pcb-form {
  .pcb-form__divider {
    background: linear-gradient(90deg, #fff, #e3e3e3 50%, #fff);
    .el-divider__text {
      font-size: $--font-size-base;
      font-weight: 700;
      color: $--color-text-primary;
    }
  }
  .quote-container__multicolumn {
    display: flex;
    justify-content: flex-start;
  }
}
</style>